import { toast } from '@conexasaude/conexa-hero'
import { openWhatsappSupport } from '@/utils/openWhatsappSupport'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const handleLoginError = (
  // eslint-disable-next-line
  error: any,
  redirectToActivation: () => void,
): void => {
  if (error?.response?.data?.msg === 'STATUS_USUARIO_INATIVO') {
    toast({
      message:
        'Notamos que você não ativou sua conta. Para realizar ou agendar uma consulta, ative sua conta agora.',
      actionLabel: 'Ativar conta',
      action: redirectToActivation,
      variant: 'warning',
    })

    return
  }

  if (error?.response?.data?.msg === 'STATUS_USUARIO_INATIVO_DEPENDENTE') {
    toast({
      message:
        'Para continuar, você precisa ativar sua conta ou a dos seus dependentes.',
      ...(window?.innerWidth >= 639 && {
        action: redirectToActivation,
        actionLabel: 'Ativar conta',
      }),
      variant: 'warning',
    })

    return
  }

  if (error?.response?.data?.status === 401) {
    const errorMessage =
      error?.response?.data?.msg || error?.response?.msg || error?.message

    toast({
      message: errorMessage,
      variant: 'error',
    })
    return
  }

  if (error?.response?.data?.status === 422) {
    const errorMessage =
      error?.response?.data?.msg || error?.response?.msg || error?.message

    if (
      error?.response?.data?.msg ===
      'Não encontramos nenhuma conta associada a este e-mail ou CPF. Por favor, tente novamente ou fale com Suporte.'
    ) {
      const toastMessageId = toast({
        message: errorMessage,
        variant: 'warning',
        autoClose: false,
        ...(window?.innerWidth >= 639 && {
          action: () => {
            openWhatsappSupport()
            toast.removeToast(toastMessageId)
          },
          actionLabel: 'Falar com Suporte',
        }),
      })
    } else {
      toast({
        message: errorMessage,
        variant: 'error',
      })
    }
    return
  }

  const errorMessage =
    error?.response?.data?.msg || error?.response?.msg || error?.message

  toast({
    message: errorMessage,
    variant: 'error',
  })
}
